module.exports = __webpack_public_path__ + "img/winner1.ad4971ea.png";